import { render, staticRenderFns } from "./editMaterial.vue?vue&type=template&id=861f3aec&scoped=true&"
import script from "./editMaterial.vue?vue&type=script&lang=js&"
export * from "./editMaterial.vue?vue&type=script&lang=js&"
import style0 from "./editMaterial.vue?vue&type=style&index=0&id=861f3aec&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "861f3aec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\gongfeng\\CVSCRM_CODE\\scrm_manage_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('861f3aec')) {
      api.createRecord('861f3aec', component.options)
    } else {
      api.reload('861f3aec', component.options)
    }
    module.hot.accept("./editMaterial.vue?vue&type=template&id=861f3aec&scoped=true&", function () {
      api.rerender('861f3aec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/web/publicizeMaterialManagement/editMaterial.vue"
export default component.exports